import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { get, remove } from 'lodash';
import React from 'react';
import { RadioGroup, RadioItem } from 'src/components/Antd';
import InformationSelection from 'src/constrains/InformationFieldsSelectTable';
import { useI18n } from 'src/hooks/useRouterChange';
import Section from 'src/pages/SalesCannelVersion/Components/SectionContainer';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { RegistrationErrorContext } from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelRegistration/ErrorContext';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

export enum EFormSetting {
  SKIPPABLE = 'SKIPPABLE',
  NON_SKIPPABLE = 'NON_SKIPPABLE',
}

const Registration = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, fields, onChange, setHasModified, disableEdit } = props;

  const { regEmptyError, setRegEmptyError } = React.useContext(
    RegistrationErrorContext,
  );
  const customerInfoFormSetting = get(data, 'customerInfoFormSetting');
  const customerInfoFields = get(data, 'customerInfoFields', []);
  //console.log('customerInfoFields', customerInfoFields);

  React.useEffect(() => {
    if (fields) {
      const fieldsUuid = fields.map((i) => i.uuid);

      const currentFields = customerInfoFields.map((i) => {
        const uuid = get(i, 'field.uuid');
        return uuid;
      });

      const shouldBeRemovedUuids = currentFields.filter(
        (i) => !fieldsUuid.includes(i),
      );

      if (shouldBeRemovedUuids.length > 0) {
        const _customerInfoFields = [...customerInfoFields];
        remove(_customerInfoFields, (x) => {
          const uuid = get(x, 'field.uuid');
          return shouldBeRemovedUuids.includes(uuid);
        });

        if (onChange) {
          onChange({
            ...(data || {}),
            customerInfoFields: _customerInfoFields,
          });
        }
      }
    } else {
    }
  }, [fields]);
  //check Fields
  const _setHasModified = () => {
    setHasModified(true);
  };

  const handleOnSettingChange = (e) => {
    const customerInfoFormSetting = e.target.value;
    _setHasModified();
    const _data = { ...data };
    if (onChange) {
      onChange({
        ...(_data || {}),
        customerInfoFormSetting,
      });
    }
  };
  const handleOnTableChange = (table) => {
    setRegEmptyError(false);
    const _data = { ...data };
    if (onChange) {
      onChange({
        ...(_data || {}),
        customerInfoFields: table,
      });
    }
  };

  return (
    <SectionWrapper
      title={getI18n('salesChannelRegistration.index.registrationInformation')}
      containerClassName={css.containerClassName}>
      <Section bottomBorder>
        <ItemWrapper
          title={getI18n(
            'salesChannelRegistration.index.customerInformationFormSetting',
          )}>
          <RadioGroup
            disabled={disableEdit}
            className={css.group}
            onChange={handleOnSettingChange}
            value={customerInfoFormSetting}>
            <div className={css.radioContainer1}>
              <RadioItem value={EFormSetting.NON_SKIPPABLE}>
                {getI18n('salesChannelRegistration.index.nonskippable')}
              </RadioItem>
              <div className={css.ratioTop}>
                {getI18n('salesChannelRegistration.index.noskippabletip')}
              </div>
            </div>
            <div className={css.radioContainer}>
              <RadioItem value={EFormSetting.SKIPPABLE}>
                {getI18n('salesChannelRegistration.index.skippable')}
              </RadioItem>
              <div className={css.ratioTop}>
                {getI18n('salesChannelRegistration.index.skippabletip')}
              </div>
            </div>
          </RadioGroup>
        </ItemWrapper>
      </Section>
      <Section>
        <InformationSelection
          data={customerInfoFields}
          setHasModified={setHasModified}
          onChange={handleOnTableChange}
          id='SalesChannelRegistrationInformationTable'
          fields={fields}
          error={{
            emptyError: regEmptyError,
            setEmptyError: setRegEmptyError,
          }}
          tip={getI18n(
            'salesChannelRegistration.index.informationSelectiontip',
          )}
          disableEdit={disableEdit}
        />
      </Section>
    </SectionWrapper>
  );
};
export default Registration;
